import React from 'react';
import { FormField, Input, InputTypes } from 'taboola-ultimate-ui';
import { useEventValueHandler } from 'hooks';
import { withIndication } from 'modules/errors';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { useFormValidatedValue, validationFunctions } from 'modules/taboola-common-frontend-modules/validations';

const InputWithIndication = withIndication(Input);

const validations = [
    {
        validationFn: (value, options, { skipValidations }) => {
            if (skipValidations) {
                return true;
            }

            return validationFunctions.isNotEmptyString(value, options);
        },
        messageId: 'landing.pages.form.validations.title.empty',
        defaultMessage: 'Please enter a page name',
    },
];

export const Title = ({ className, showDescription = true, skipValidations, disabled = false }) => {
    const {
        value: title,
        onChange: onChangeTitle,
        indicationData,
        scrollRef,
    } = useFormValidatedValue({
        field: 'title',
        validations,
        validationDependencies: { skipValidations },
    });
    const changeHandler = useEventValueHandler(onChangeTitle);
    const { formatMessage } = useIntl();
    const placeholder = formatMessage({
        id: 'landing.pages.form.title.placeholder',
        defaultMessage: 'Use a unique and descriptive name for your page...',
    });

    return (
        <FormField
            ref={scrollRef}
            inputId="title"
            label={<FormattedMessage id="landing-pages.page.title.input.label" defaultMessage="Landing Page Name" />}
            description={
                showDescription && (
                    <FormattedMessage
                        id="landing.pages.form.title.input.description"
                        defaultMessage="Use a unique and descriptive name for your page"
                    />
                )
            }
        >
            <InputWithIndication
                id="title"
                placeholder={placeholder}
                type={InputTypes.TEXT}
                value={title ?? ''}
                onChange={changeHandler}
                disabled={disabled}
                data-metrics-event-name={GTM_EVENTS.USABILITY}
                data-metrics-component="title"
                inputClass={className}
                inputWrapperClass={className}
                {...indicationData}
            />
        </FormField>
    );
};
